import { Row, Container, ListGroup } from 'react-bootstrap';

export default function BecomingHostsStep() {
  return (
    <Row className="mx-auto">
      <Container className="p-5">
        <h3 className="h2 pb-5 text-center">Steps to Becoming a Host</h3>
        <ListGroup>
          <ListGroup.Item>
            <div className="d-flex w-100">
              <div className="p-3 h1 d-flex align-content-center flex-wrap">
                1
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Apply to become host</span>
                  <p className="mb-1">
                    Fill in the host application form here.
                  </p>
                </div>
              </div>
            </div>
          </ListGroup.Item>
          <ListGroup.Item>
            <div className="d-flex w-100">
              <div className="p-3 h1 d-flex align-content-center flex-wrap">
                2
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Add Trips</span>
                  <p className="mb-1">
                    Use our simple online system, to add your adventures.
                  </p>
                </div>
              </div>
            </div>
          </ListGroup.Item>
          <ListGroup.Item>
            <div className="d-flex w-100">
              <div className="p-3 h1 d-flex align-content-center flex-wrap">
                3
              </div>
              <div className="p-3 flex-grow-1 d-flex align-content-center flex-wrap">
                <div className="w-100">
                  <span className="lead">Get your first customers</span>
                  <p className="mb-1">
                    Offer a kick-ass experience to your first customers.
                  </p>
                </div>
              </div>
            </div>
          </ListGroup.Item>
        </ListGroup>
      </Container>
    </Row>
  );
}
